import React, { FC, useState } from 'react';

import { ChevronDownIcon } from '../../../assets/icons/index';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '../../../components/combobox/index';
import { TerminationInterval, terminationIntervalTitle } from '../../../types/pool-plans.types';

const IntervalItemsList: FC = () => {
  return (
    <>
      {Object.entries(terminationIntervalTitle).map(([key, value]) => (
        <ComboboxOption key={key} value={key}>
          <span className="text-sm text-gray-700">
            <AppFormattedMessage id={value} />
          </span>
        </ComboboxOption>
      ))}
    </>
  );
};

export type IntervalComboboxProps = {
  defaultData?: TerminationInterval;
  onSelect?: (state: TerminationInterval) => void;
};

export const IntervalCombobox: FC<IntervalComboboxProps> = ({ defaultData, onSelect }) => {
  const [value, setValue] = useState<null | TerminationInterval>(defaultData || null);
  return (
    <Combobox
      as={'div'}
      className="relative"
      onChange={(value: TerminationInterval) => {
        onSelect?.(value);
        setValue(value);
      }}
    >
      <div className="relative">
        <ComboboxInput
          className={'bg-gray-900'}
          icon={<ChevronDownIcon className="mt-2" />}
          name={'stepOne.type'}
          onChange={() => ''}
          placeholder={<AppFormattedMessage id="INTERVAL" />}
          readOnly
          value={value ? terminationIntervalTitle[value] : ''}
        />
        <ComboboxButton className="absolute left-0 top-0 z-1 h-full w-full" />
      </div>
      <ComboboxOptions className="w-full">
        <IntervalItemsList />
      </ComboboxOptions>
    </Combobox>
  );
};
